import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import { fetchUser } from "../redux/api/user.api";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { removeUserToken } from "../redux/reducer/auth.reducer";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoute";
import { initialMainRoute } from "./routesConstants";
import ScrollToTop from "./scrollToTop";
import useAppRoutes from "./useAppRoutes";
import { unauthorizedEventName } from "../helpers/apiHelper";
import { subscribeToAuthChanges } from "../helpers/storageHelper";

const MainRoutes = () => {
  const dispatch = useAppDispatch();

  const { errorRoutes, allRoutes } = useAppRoutes();

  const {
    auth: { token },
  } = useAppSelector((state) => ({
    auth: state.auth,
  }));

  useEffect(() => {
    if (token) {
      dispatch(fetchUser());
    } else {
      dispatch(removeUserToken());
    }
  }, [dispatch, token]);

  useEffect(() => {
    const handleUnauthorized = () => {
      dispatch(removeUserToken());
    };

    window.addEventListener(unauthorizedEventName, handleUnauthorized);

    return () => {
      window.removeEventListener(unauthorizedEventName, handleUnauthorized);
    };
  }, [dispatch]);

  useEffect(() => {
    return subscribeToAuthChanges(() => window.location.reload());
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to={`/${initialMainRoute}`} />} />
          {errorRoutes.map(({ id, path, element }) => {
            return <Route key={id} path={path} element={element} />;
          })}
          <Route element={<ProtectedRoute isAuthorized={!!token} />}>
            <Route path={`/${initialMainRoute}`} element={<Home />}>
              <Route path=":userId" element={<Home />} />
            </Route>
            {allRoutes.map(({ id, path, element }) => {
              return <Route key={id} path={path} element={element} />;
            })}
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAuthorized={!token}
                redirectPath={`/${initialMainRoute}`}
              />
            }>
            <Route path={"/login"} element={<Login />} />;
            {/* <Route path="/dashboard" element={<Home />}>
               <Route path=":userId" element={<Home />} />
            </Route> */}
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
};

export default MainRoutes;
